import { SortingState } from "@tanstack/react-table";
import { split } from "lodash";

import { DEFAULT_ORDER } from "../constants/default_order";
import { SimpleOrder } from "../table/contexts/skills_management_context_provider";

export const getOrderForRequest = (
  order: SortingState,
  orderOptions?: SimpleOrder[]
): SimpleOrder | undefined => {
  if (!orderOptions || orderOptions.length === 0) {
    return DEFAULT_ORDER;
  }

  return orderOptions.find(
    ({ name, direction }) =>
      name[0] === `custom_values.${order?.[0]?.id}` && direction === (order?.[0]?.desc ? "desc" : "asc")
  );
};

export const getOrderForTable = (order?: SimpleOrder) =>
  order
    ? [
        {
          id: split(order.name[0], ".")[1],
          desc: order.direction === "desc"
        }
      ]
    : [];
